<template>
    <div class="main-body">
        <div class="header">盘点记录</div>
        <div class="out">

          <div class="search2">

            <el-button size="mini" type="primary" plain @click="showCart">新增盘点</el-button>

            <div style="float:right;">

              <el-select v-model="institutionCode" placeholder="请选择机构">
                <el-option
                    v-for="item in arr_ins"
                    :key="item.institutionCode"
                    :label="item.userName"
                    :value="item.institutionCode">
                </el-option>
              </el-select>

              <el-button size="mini" style="margin-left:5px;float:right" plain type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

            </div>
            <div style="clear: both;"></div>
          </div>

            <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border>
                <el-table-column prop="waresName" label="物品名称" width="200" ></el-table-column>
                <el-table-column prop="stockCount" label="库存" width="200" ></el-table-column>
                <el-table-column prop="inventoryCount" label="盘点数" width="200" ></el-table-column>
                <el-table-column prop="createTime" :formatter="timefilter" width="200" label="日期"></el-table-column>
                <el-table-column prop="remarks" label="备注"></el-table-column>
            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>



      <Cart ref="myCart" v-show="showModalCart" v-on:closeCart="showModalCart=false"
               v-on:getList="getList" v-bind:arr_ins="arr_ins"></Cart>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    import Cart from "./Cart";

    export default {
        name: "Page",
        data(){
            return{
                loading:false,

              showModalCart:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

              arr_ins:[],
              institutionCode: '',


            }
        },
        components:{
          Cart
        },
        created(){
            this.getIns();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

          getIns(){

            this.$axios({
              method: 'post',
              url: this.$shopUrl+"Institution/ListType",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: getStaffCode(),
                type:1,
              }
            }).then((response) => {

              if (response.data.error === 0) {
                this.arr_ins = response.data.data.list;
                if(this.arr_ins.length>0){
                  this.institutionCode = this.arr_ins[0].institutionCode;
                  this.getList();
                }
              }else if(response.data.error === 1){
                this.$message.error(response.data.message)
              }

            })

          },


          showCart(){
            this.$refs.myCart.init(this.institutionCode);
            this.showModalCart = !this.showModalCart;
          },


          timefilter(row, column, cellValue){
            return timefilters(cellValue)
          },

          current_change:function(currentPage){
              this.currentPage = currentPage;
              this.getList();
          },
          getList(){
              this.loading=true;
              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+"Inventory/GovPageIns",
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),
                    institutionCode:this.institutionCode,
                      pageIndex:this.currentPage,
                      pageSize:this.pageSize,
                  }
              }).then( (response)=> {
                  this.loading=false;
                  if(response.data.error == 0){
                      this.tableData = response.data.data.list;
                      this.totalItems = response.data.data.total;
                  }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          },


          statusTitle(row){
              if(row.status == 0){
                  return "正常";
              }
              if(row.status == 1){
                  return "禁用";
              }
              return "其它";
          },


        }
    }
</script>

<style scoped>

</style>
